"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Input {
    dump() {
        return JSON.stringify(this);
    }
    get() {
        if (this.interator >= this.inp.length)
            throw "INPUT GET OUT OF RANGE";
        this.interator++;
        return this.inp[this.interator - 1];
    }
    constructor(inp) {
        if (typeof inp === typeof undefined)
            inp = [];
        this.inp = inp;
        this.interator = 0;
    }
}
exports.Input = Input;
class Output {
    dump() {
        return JSON.stringify(this);
    }
    put(val) {
        if (typeof val === typeof undefined || val === null)
            throw "OUTPUT PUT UNDEFINED VALUE";
        this.outp.push(val);
    }
    get() {
        return this.outp;
    }
    constructor() {
        this.outp = [];
    }
}
exports.Output = Output;
//# sourceMappingURL=IO.js.map


// WEBPACK FOOTER //
// ./utilities/RM/IO.js